const CDN_BASE = import.meta.env.VITE_CDN_BASE_URL;

if (CDN_BASE) {
  console.info(`[CDN] Base URL: ${CDN_BASE}`);
} else {
  console.info('[CDN] No VITE_CDN_BASE_URL set, using local assets');
}

export const resolveCdnUrl = (path: string): string =>
  CDN_BASE ? `${CDN_BASE}/${path}` : `/${path}`;

export const isCdnUrl = (url: string): boolean =>
  Boolean(CDN_BASE) && url.startsWith(`${CDN_BASE}/`);

export const toLocalUrl = (url: string): string => {
  if (CDN_BASE && url.startsWith(`${CDN_BASE}/`)) {
    return url.slice(CDN_BASE.length);
  }
  return url;
};
